// How the promotion wizard behaves while Autopilot is on. Both rules read the
// same three inputs and both were review catches, so they live together and
// are tested rather than buried in a 1100-line screen.

/**
 * Whether the wizard should derive the Autopilot promo shape (one step, server
 * scheduling).
 *
 * Create-under-Autopilot: yes. Edit: never - the api refuses to open an
 * Autopilot-scheduled promotion, so an edit is always a manual one and needs
 * the full three-step wizard even while Autopilot is on.
 */
export const shouldDeriveAutopilotPromo = (
    listingType: string | null | undefined,
    editCampaignId: string | undefined,
): boolean => listingType === "Promotion" && !editCampaignId;

/**
 * Whether Autopilot owns Instagram volume, so the wizard's account-wide 3/week
 * gate steps aside.
 *
 * MB-1409: that gate counts the fleet's own Instagram posts (Cruise plans 6/week
 * by design), so leaving it on would show a promotion zero selectable Instagram
 * days. The server keeps IG safe on this path via the 1/week promo cap and the
 * renewal-time trim.
 */
export const autopilotOwnsInstagram = (
    autopilotPromo: boolean,
    autopilotEnabled: boolean | null | undefined,
    listingType: string | null | undefined,
): boolean =>
    autopilotPromo || (autopilotEnabled === true && listingType === "Promotion");
